/*  Add copy and paste Mar 13, 2022 */
<template lang="pug">
	div(:class="'kta-' + p_node.typeLbl")
		div(class="name")
			fa-icon(:icon="p_node.fn_icon()")
			span(v-if="!d_inRename" @click="m_nameClick") {{p_node.name}} 
			div(v-else class="input-name")
				input(ref="input-name" type='text' maxlength=100 v-model="d_inputRename" required
					:placeholder="'Enter a ' + (p_node.isFolder? 'Folder': 'File') + ' Name'"
					@keyup.enter="m_renameSave" :invalid="p_node.isDupNm")
				fa-icon(icon="check" @click="m_renameSave" title="Save")
				small(v-if="p_node.isDupNm") A {{p_node.typeLbl}} with the same name already exists in the current folder. Please enter a unique name.
		div
			div(class="info")
				span(v-if="p_node.isFolder" v-show="!c_isNewFldr") {{p_node.fn_nodesCntTxt()}}
				span(v-else) {{p_node.extension}}  {{p_node.fn_fileSizeFmt()}}
			div(class="btns")
				span(v-if="p_node.isLoading" class="text-primary spinner-border spinner-border-sm mx-1" role="status")
				span(v-else-if="p_node.isError" v-b-tooltip.hover.auto.ds500="'Error Occured'")
					fa-icon(icon="exclamation-triangle" class="text-danger")
				b-button(id="btn-copy" v-if="!p_node.isFolder" class="btn-copy" variant="outline-secondary" @click="m_copyFile"
					v-b-tooltip:dragbox.hover.topleft.ds500="'Copy'")
					fa-icon(icon="copy")
				b-button(v-if="p_node.isFolder" class="btn-download" variant="outline-secondary"
					@click="p_node.fn_download()"
					v-b-tooltip:dragbox.hover.topleft.ds500="'Download'+ (p_node.isFolder?' (as zip)':'')")
					fa-icon(icon="download")
				b-button(class="btn-move" variant="outline-secondary" v-show="!c_isNewFldr" 
					@click="p_node.fn_moveTo(null)"
					v-b-tooltip:dragbox.hover.topleft.ds500="'Move'")
					fa-icon(icon="folder-minus")
				b-button(class="btn-rename" variant="outline-secondary" v-show="!c_isNewFldr" 
					@click="m_renameClick"
					v-b-tooltip:dragbox.hover.topleft.ds500="d_inRename?'Cancel Rename':'Rename'")
					fa-icon(:icon="d_inRename ? 'times':'pen'")
				b-button(class="btn-delete" variant="outline-danger" 
					@click="p_node.fn_delete()"
					v-b-tooltip:dragbox.hover.topleft.ds500="'Delete'")
					fa-icon(icon="trash-alt")




</template>

 <script>
//import { eventBus } from '@/main';
import KTAttachNode from "@/components/Ctrl/KT-AttachNode.vue";
export default {
	name: "kt-attach-node",
	components: {
		'kt-attach-node': KTAttachNode
	},
	created() {
		let pn = this.p_node;
		if (pn.isFolder && !pn.isRoot && !pn.attachmentFolderId) {
			this.m_renameClick({});
			this.d_inputRename = null;
		}
		if (pn.isDupNm) {
			this.m_renameClick({});
		}
	},
	mounted() {
	document.querySelector("#btn-copy").addEventListener('dblclick', function() {
			window.sessionStorage.removeItem('copiedFiles');
			window.sessionStorage.removeItem('copiedFileNames');
			
		})
	},
	data() {
		return {
			d_inRename: null,
			d_inputRename: null,
		};
	},
	props: {
		p_node: {type: Object, required: true},
	},
	computed: {
		c_isNewFldr() {
			return this.p_node.isFolder && this.p_node.attachmentFolderId == null;
		}
	},
	methods: {
		m_copyFile(){
			if(this.p_node.attachmentId){
			var attachmentString=this.p_node.attachmentId.toString();
			var copiedFiles=window.sessionStorage.getItem('copiedFiles');
			var copiedFileNames=window.sessionStorage.getItem('copiedFileNames');
			var replaceName1=","+this.p_node.name;
			var replaceRegExp2="^"+this.p_node.name+",";
			var replaceName3=this.p_node.name;
			if ((copiedFiles) && (copiedFiles != undefined)){	
				if(copiedFiles.includes(attachmentString)){
					window.sessionStorage.setItem('copiedFiles',(copiedFiles.replace(attachmentString,'')).trim());
					window.sessionStorage.setItem('copiedFileNames',((copiedFileNames.replace(replaceName1,'')).replace(replaceRegExp2,'')).replace(replaceName3,''));
				}else {
						window.sessionStorage.setItem('copiedFiles', copiedFiles+' '+ attachmentString);
						window.sessionStorage.setItem('copiedFileNames', copiedFileNames+','+ this.p_node.name);
						}
				}
			else {
					window.sessionStorage.setItem('copiedFiles',attachmentString);
					window.sessionStorage.setItem('copiedFileNames',this.p_node.name);
				}
			}
			
	},
		m_renameClick(e) {
			if (e.detail > 1) return;
			let pn = this.p_node;
			if (this.d_inRename) {
				// if (pn.isDupNm && this.d_inputRename == pn.name) return;
				this.d_inRename = pn.isDupNm = null;
				return;
			}
			this.d_inRename = true;
			this.d_inputRename = pn.name;
			setTimeout(() => {
				let $nm = $(this.$refs['input-name']);
				$nm.focus();
				$nm.select();
			}, 100);
		},
		m_renameSave(e) {
			e.stopPropagation(); //Prevnt @click on name
			if (e.detail > 1) return;
			let ir = this.d_inputRename;
			if (!ir) return;
			ir = ir.trim();

			let pn = this.p_node;

			let dup = pn.parent.nodes.filter(x => {
				return (pn.isFolder || false) == (x.isFolder || false)
					&& x.name.toLowerCase() == ir.toLowerCase()
					&& x.clntId != pn.clntId;
			});
			if (dup.length > 0) {
				pn.isDupNm = true;
				return;
			}
			if (pn.name != ir) {
				pn.name = ir;
				pn.fn_saveChanges();
			}
			this.d_inRename = this.d_inputRename = pn.isDupNm = null;
		},
		m_nameClick(e) {
			if (e.detail > 1) return;
			let pn = this.p_node;
			if (pn.isFolder) pn.fn_openFolder();
			else pn.fn_openFile();
		}
	},
	watch: {}
};
</script>

<style lang="less">
.kta-folder,
.kta-file {
	display: flex;
	flex-wrap: wrap;
	font-size: 0.9em;
	padding: 0.2em 0;
	margin: 0.2em 0.25em 0.2em 1.25em;

	padding-left: 0.25em;
	border-bottom: solid 0.1em #ced4da;
	div.name {
		display: flex;
		flex-grow: 1;
		padding-right: 0.5em;

		> div.input-name {
			display: flex;
			position: relative;
			flex-direction: column;
			flex-grow: 1;
			padding-right: 0.5em;
			> input {
				outline: 0;
				border: solid 0.1em #adb5bd;
				padding: 0em 0.2em;
				padding-right: 1.5em;
				border-radius: 0.2em;

				&:focus {
					// background-color: #4fa4ff40;
					box-shadow: 0 0 0 0.1rem #4fa4ff40;
				}
				&:invalid,
				&[invalid] {
					border-color: #dc3545;
					box-shadow: none;
				}
			}
			> svg.fa-check {
				position: absolute;
				top: 0.35em;
				right: 1em;
				opacity: 0.5;
				font-size: 14px;
				cursor: pointer;
				&:hover {
					opacity: unset;
					color: #4fa4ff;
				}
			}
			> small {
				color: #dc3545;
			}
		}

		> svg {
			margin: auto 0;
			margin-right: 0.2em;
			width: 20px;
			font-size: 1.1em;
		}
		> span {
			margin: auto 0;
			-ms-word-break: break-all;
			word-break: break-all;
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 2; /* number of lines to show */
			-webkit-box-orient: vertical;

			cursor: pointer;
			&:hover {
				text-decoration: underline;
				color: #4fa4ff;
			}
		}
	}
	> div:last-child {
		margin-left: auto;
		display: flex;
		div.info {
			min-width: 85px;
			margin: auto 0;
			text-align: right;
			margin-left: auto;
			font-size: 0.8em;
		}
		div.btns {
			// border: solid 0.1em blue;
			min-width: 100px;
			max-width: 130px;
			text-align: right;
			padding: 0 0.2em;
			button.btn {
				font-size: 0.85em;
				padding: 0.3em 0.2em;
				margin: 0 0.1em;
				border-radius: 0.2em;
				line-height: 1em;
				opacity: 0.5;
				border: none;
				width: 20px;
			}
		}
	}

	&:hover {
		background-color: #dee2e6;
	}
}

.kta-folder {
	div.name {
		> svg {
			&.fa-folder-open {
				color: #4fa4ff;
				opacity: 0.5;
			}
		}
		&:hover > svg.fa-folder-open {
			opacity: unset;
		}

		&:focus span {
			font-weight: bolder;
			color: red;
		}
	}

	div.info {
		color: #4fa4ff;
	}
}

.kta-file {
	div.name {
		> svg {
			opacity: 0.5;

			&.fa-file {
				color: #343a40;
			}
			&.fa-file-pdf {
				color: #fd9494;
			}
			&.fa-file-word {
				color: #8fbef0;
			}
			&.fa-file-excel {
				color: #66ca7d;
			}
			&.fa-file-powerpoint {
				color: #ec7a4e;
			}
			&.fa-file-image {
				color: #6f42c1;
			}
			&.fa-file-archive {
				color: #6c757d;
			}
			&.fa-file-csv,
			&.fa-file-alt {
				color: #adb5bd;
			}
			&.fa-folder {
				color: #ffc107;
			}
		}
		&:hover > svg {
			opacity: unset;
		}
	}
}
</style>



